<script>
	import { onMount } from 'svelte';
	import idleTimeout from 'idle-timeout';
	import Modal from '@ctm/ui/src/components/Modal/Modal.svelte';
	import modalService from '@ctm/ui/src/components/Modal/modal';
	import { signOutUser } from '@ctm/auth';
	import { signedInUser } from '@ctm/auth/store';

	export let timeout = 1000 * 60 * 20;
	export let timeoutCountdown = 1000 * 60 * 2;

	let timeoutFn = 0;

	onMount(() => {
		initIdleTimeout();
	});

	function initIdleTimeout() {
		const modalTimeout = timeout - timeoutCountdown;

		idleTimeout(
			() => {
				createCountdown();
				showModal();
			},
			{
				timeout: modalTimeout,
			},
		);
	}

	function showModal() {
		modalService
			.open(
				Modal,
				{
					title: 'Are you still there?',
					okText: 'Continue',
					hasCancelButton: false,
					isClosable: false,
					isOverlayClosable: false,
					isKeyboardClosable: false,
				},
				`For your security, you will be signed out due to ${timeout / 1000 / 60} minutes of inactivity. Click continue to remain signed in.`,
			)
			.then(() => {
				clearCountdown();
				initIdleTimeout();
			});
	}

	function createCountdown() {
		timeoutFn = setTimeout(() => {
			modalService.remove();
			signOut();
		}, timeoutCountdown);
	}

	function clearCountdown() {
		clearTimeout(timeoutFn);
	}

	function signOut() {
		const user = $signedInUser;
		if (user) {
			signOutUser({ inactivityTimeout: true, login_hint: user.email });
		} else {
			signOutUser({ inactivityTimeout: true });
		}
	}
</script>
